<template>
  <div class="memorycard">
    <div class="front border rounded shadow fill">
      <img
        :width="width"
        :height="height"
        src="/assets/img/games/matchgame/pattern/pattern1.jpg"
      />
    </div>
    <div class="back border rounded fill">
      <img
        :width="width"
        :height="height"
        :src="`/resources/images/fruits/${card.img}`"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  components: {},
  props: {
    card: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  data() {
    return {
      width: 150,
      height: 150
    };
  }
};
</script>

<style lang="scss" scoped>
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.matched {
  opacity: 0.3;
}
.fill {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.fill img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}

img {
  object-fit: cover;
}
</style>
